import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Zap, CalendarClock } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { SlotPicker } from "@/components/SlotPicker";

export const MissedRecovery = ({ b, onDone }) => {
  const { t } = useApp();
  const [mode, setMode] = useState("");
  const [form, setForm] = useState({ date: "", slot: "" });
  const [busy, setBusy] = useState(false);
  if (b.recovery !== "awaiting_customer" || !b.missed) return null;
  const go = async (choice) => {
    if (choice === "reschedule" && (!form.date || !form.slot)) return toast.error(t("Please pick a date and time slot."));
    setBusy(true);
    try { const { data } = await api.post(`/bookings/${b.booking_id}/recover`, { choice, ...form }); toast.success(data.message); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="ks-rise space-y-3 rounded-3xl border-2 border-[#E05C3A] bg-[#FDF1EC] p-4" data-testid="missed-recovery">
      <p className="flex items-center gap-2 font-display text-lg font-bold text-[#B4401F]"><AlertTriangle className="h-5 w-5" />{t("Your pickup couldn't be completed")}</p>
      <p className="text-sm text-[#0D3B2B]" data-testid="missed-reason">{t("Reason")}: <b>{t(b.missed.reason)}</b>{b.missed.note ? ` — ${b.missed.note}` : ""}</p>
      <p className="text-sm text-[#4A6358]">{t("We're sorry. Choose what you'd like us to do:")} {t("If you don't choose within 2 hours, we'll automatically send another partner in the next slot.")}</p>
      <button onClick={() => go("now")} disabled={busy} data-testid="recover-now-btn"
        className="flex h-14 w-full items-center justify-center gap-2 rounded-2xl bg-[#2E9E6B] font-bold text-white transition-transform active:scale-[.98] disabled:opacity-50"><Zap className="h-5 w-5" />{t("Send another partner now")}</button>
      <button onClick={() => setMode(mode ? "" : "pick")} data-testid="recover-reschedule-toggle"
        className="flex h-14 w-full items-center justify-center gap-2 rounded-2xl border-2 border-[#0D3B2B] bg-white font-bold text-[#0D3B2B]"><CalendarClock className="h-5 w-5" />{t("Pick a new date & time")}</button>
      {mode === "pick" && (
        <div className="space-y-3 rounded-2xl bg-white p-3" data-testid="recover-slot-picker">
          <SlotPicker form={form} set={(o) => setForm((f) => ({ ...f, ...o }))} />
          <button onClick={() => go("reschedule")} disabled={busy} data-testid="recover-reschedule-btn" className="h-12 w-full rounded-2xl bg-[#0D3B2B] font-bold text-white disabled:opacity-50">{t("Confirm new time")}</button>
        </div>
      )}
      <p className="text-xs text-[#7B968B]">{t("You can also cancel this pickup below.")}</p>
    </div>
  );
};
